import { ValidateRule, ValidateInputProps } from "./types"
import { useState, useCallback } from "react"
import { validateSingle } from "~utils/validator"

const useValidateInput = (validRule: ValidateRule) => {
  const [error, setError] = useState<ValidateInputProps["error"]>(false)
  const validate = useCallback(
    (value: any) => {
      setError(validateSingle(validRule, value))
    },
    [validRule],
  )
  return { error, validate }
}

export default useValidateInput
